import axiosInstance from "../axiosInstance";

export const reportsApi = {
  post: (path, params, headers, cancelToken) =>
    axiosInstance
      .post(`/Reports${path}`, params, {
        responseType: "blob",
        withCredentials: "true",
        cancelToken: cancelToken?.token,
        headers,
      })
      .then((res) => {
        if (res?.data?.error) throw res.data;

        return res;
        // if (res?.data?.error || res?.data?.status === 'error') throw res.data;
      })
      .catch((err) => {
        throw err.error ? err : err?.response?.data;
      }),
  get: (path, params, headers, cancelToken) =>
    axiosInstance
      .get(
        `/Reports${path}`,
        { params },
        {
          cancelToken: cancelToken?.token,
          headers,
        }
      )
      .then((res) => {
        if (res?.data?.error) throw res.data;
        return res?.data;
      })
      .catch((err) => {
        throw err.error ? err : err?.response?.data;
      }),
};

export const getReport = async (params) =>
  reportsApi.post("/Get", JSON.stringify(params), {
    "Content-Type": "application/json",
  });
